import React, { useEffect } from "react";
import "./about.css";

function About(props) {
  document.title = "JXSRMA | " + props.title;
  useEffect(() => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}, [])
  return (
    <div className="about" id="about">
      <h1>About</h1>
      <div className="about-content">
        <div className="about-para">
          <p>
            🎵🌟 Jash Sharma, born on 3rd August 2001 in Indore, India, is a
            young and growing music producer. Despite lacking a musical
            background, he fearlessly entered the music scene in 2017. 🚀 In
            2020, under the pseudonym <span>JXSRMA</span>, he amazed listeners
            with his first release "All Together". 🎶🎉
          </p>
          <p>
            🎓💻 Alongside his passion for music, Jash is a computer geek
            pursuing a degree in computer science. 📚💿 Balancing his studies
            and music career, he continues to learn and evolve as a music
            producer, showcasing his remarkable talent. 🎹🎧
          </p>
          <p>
            🌟👏 Since his initial release, Jash has delighted fans with more
            incredible work, receiving well-deserved acclaim for his commendable
            achievements. 🎶💯
          </p>
          <p>
            Jash Sharma is a testament to the power of passion and
            determination, blending the worlds of music and technology to create
            something truly extraordinary. 🎵🔥 Keep an eye on this exceptional
            artist as he continues to make waves in the music industry! 🌊🎶
          </p>
        </div>
        <div className="about-images">
          <img src="https://i.ibb.co/nfVB7nc/divider.jpg" alt="" />
          {/* <img src="https://wallpapercave.com/wp/wp6988384.jpg" alt="" />
        <img src="https://wallpapercave.com/wp/wp6988384.jpg" alt="" />
        <img src="https://wallpapercave.com/wp/wp6988384.jpg" alt="" /> */}
        </div>
      </div>
    </div>
  );
}

export default About;
